export default __webpack_public_path__ + "images/SAPB1LogoSVG.svg";